import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { GoogleMapsLoaderService } from '../../_services/google-maps-loader.service';
import { PlaceService } from '../../_services/place.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CityService } from '../../_services/city.service';

declare let google: any;
declare var jQuery: any;

import '../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-new-city-modal',
  templateUrl: './new-city-modal.component.html',
  styleUrls: ['./new-city-modal.component.css']
})
export class NewCityModalComponent implements OnInit {

  @Output() refresh: EventEmitter<object> = new EventEmitter<object>();
  @ViewChild("cityInput") cityInput: ElementRef;
  @ViewChild('submitButton') submitButton: ElementRef;

  private creating_city: boolean = false;
  private new_area: boolean = false;
  private new_country: boolean = false;
  private field: string;
  cityAutocomplete: any;
  new_city: FormGroup;

  constructor(
    private elRef: ElementRef, 
    private service: PlaceService, 
    private googleMapsLoader: GoogleMapsLoaderService,
    private http: HttpClient,
    private cityService: CityService
  ) { }

  

  ngOnInit() {

    this.new_city = new FormGroup({
      city: new FormControl('', [Validators.required]),
      cp: new FormControl(''),
      area: new FormControl(''),
      country: new FormControl('', [Validators.required]),
      google_city: new FormControl(''),
      lat: new FormControl(''),
      lng: new FormControl('')
    })
  }

  ngAfterViewInit(): void {
    this.googleMapsLoader.load().then(() => {
      //this.loadMap();
      this.initializeAutocomplete();
      //this.initializeDirectionsService();
    }).catch(error => {
      console.error('erreur lors du chargement de google maps', error);
    });
  }
  openModal(field, city_name?){
    this.field = field;
    if(city_name) this.new_city.patchValue({city: city_name});
    jQuery('#add-city-modal .dropdown').dropdown('restore defaults'); // Clear the Select
    jQuery('#add-city-modal').modal({inverted: true}).modal('show');
  }

  newArea(area_name){
    this.new_city.patchValue({area: area_name});
    this.new_city.controls['country'].setValidators([Validators.required])
    this.new_area = true;
  }

  newCountry(country_name){
    this.new_city.patchValue({country: country_name});
    this.new_country = true;
  }

  submitCityForm(){
    this.new_city.disable();
    this.creating_city = true; // Disable the loading button apparition
    jQuery('#add-city-modal').modal({closable: true})
    this.createCity();
  }

  createCity() {
     
    this.service.createCity(this.new_city.value)
      .subscribe(response => {
        //console.log('response', response);
        jQuery('#add-city-modal').modal({closable: true}).modal('hide'); // Set the modal closable & Close the modal
        this.creating_city = false;
        this.new_area      = false;
        this.new_country   = false;
        this.new_city.enable(); // Re Enable the Form
        this.new_city.reset(); // Reset It
        //this.refresh.emit({field: this.field, value: response.id}); // Emmit the refresh Event
      }, error => {
        this.creating_city = false;
        this.new_area      = false;
        this.new_country   = false;
        this.new_city.enable(); // Re Enable the Form
        this.new_city.reset(); // Reset It
        this.new_city.setErrors({ error: error.error.message });
    })
  }

  initializeAutocomplete(): void {
    this.cityAutocomplete = new google.maps.places.Autocomplete(this.cityInput.nativeElement, {});
  
    this.cityAutocomplete.addListener('place_changed', async () => {
      const place = this.cityAutocomplete.getPlace();

      if (!place.geometry || !place.geometry.location) {
        return;
      }
      const region = this.getRegionFromPlace(place);
      const codePays = this.getCountryCodeFromPlace(place);
      let cp = this.getPostalCodeFromPlace(place);
      const country = this.getCountryFromPlace(place);
      const city = place.name;


      const countryRecord = await this.cityService.getOrCreateCountry(country).toPromise();

      let areaRecordId = null;
      if(region.length > 0){
        const areaRecord = await this.cityService.getOrCreateArea(region, countryRecord.id).toPromise();
        areaRecordId = areaRecord.id;
      }

      const lat = place.geometry.location.lat()
      const lng = place.geometry.location.lng()
      

      if (!cp) {
        cp = await this.fetchPostalCode(lat, lng)
      }
      cp = this.adjustPostalCode(cp, codePays);

      const cityString = city + ' ' + codePays + ' ' + cp;

      this.new_city.get('country').setValue(countryRecord.id);
      this.new_city.get('area').setValue(areaRecordId);
      this.new_city.get('city').setValue(cityString.toUpperCase());
      this.new_city.get('google_city').setValue(1);
      this.new_city.get('lat').setValue(lat);
      this.new_city.get('lng').setValue(lng);

      this.submitButton.nativeElement.focus();
    });

  }
      
  async fetchPostalCode(lat: number, lng: number): Promise <string> {
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this.googleMapsLoader.apiKey}`;

    try {
      const response: any = await this.http.get(geocodeUrl).toPromise();
      if (response.results && response.results.length > 0) {
        const postalCode = this.getPostalCodeFromGeocodeResult(response.results);
        return postalCode;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du code postal', error);
      return ''
    }
  }

  getPostalCodeFromGeocodeResult(results: any[]): string {
    for (const result of results) {
      for (const component of result.address_components) {
        if (component.types.includes("postal_code")) {
          return component.long_name;
        }
      }
    }
    return "";
  }

  adjustPostalCode(postalCode: string, countryCode: string): string {

    if (countryCode === 'FR' && postalCode.length >= 2) {
      return postalCode.substring(0, 2);
    }
    return postalCode;
  }

  getCountryFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("country")) {
        return component.long_name;
      }
    }
    return "";
  }

  getRegionFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("administrative_area_level_1")) {
        return component.long_name;
      }
    }
    return "";
  }

  getCountryCodeFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("country")) {
        return component.short_name; 
      }
    }
    return "";
  }

  getPostalCodeFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("postal_code")) {
        return component.long_name;
      }
    }
    return "";
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/new-city-modal/new-city-modal.component.ts